import { normalizeUrl } from "../helper/url";
import { isDefined } from "../helper/utils";

let _initialRestCall = true;

export function get(url, data, config)
{
    config = config || {};
    config.method = "GET";
    if (_initialRestCall)
    {
        data = data || {};
        data.initialRestCall = true;
        _initialRestCall = false;
    }
    return send(url, data, config);
}

export function put(url, data, config)
{
    config = config || {};
    config.method = "PUT";
    return send(url, data, config);
}

export function post(url, data, config)
{
    config = config || {};
    config.method = "POST";
    return send(url, data, config);
}

export function del(url, data, config)
{
    config = config || {};
    config.method = "DELETE";
    return send(url, data, config);
}

export function send(url, data = {}, config)
{
    const deferred = $.Deferred();

    data = isDefined(data) ? data : {};
    url = normalizeUrl(url);
    config = config || {};
    config.dataType = config.dataType || "json";
    config.contentType = typeof config.contentType !== "undefined" ? config.contentType : "application/x-www-form-urlencoded; charset=UTF-8";
    config.doInBackground = !!config.doInBackground;
    config.supressNotifications = !!config.supressNotifications;
    config.keepOriginalResponse = !!config.keepOriginalResponse;
    config.headers = config.headers || { "Accept-Language": App.language };

    const csrfToken = config.headers["X-CSRF-TOKEN"] || (document.getElementById("csrf-token") || {}).value;

    if (csrfToken)
    {
        config.headers["X-CSRF-TOKEN"] = csrfToken;
    }

    data.templateType = App.templateType;
    config.data = data;

    const request = $.ajax(url, config)
        .done(function(response)
        {
            if (config.keepOriginalResponse)
            {
                deferred.resolve(response);
            }
            else
            {
                deferred.resolve(response.data || response);
            }
        })
        .fail(function(jqXHR)
        {
            const response = jqXHR.responseText ? $.parseJSON(jqXHR.responseText) : {};

            deferred.reject(response, jqXHR.status);
        });

    deferred.abort = request.abort;

    return deferred;
}

export function setToken(token)
{
    this._token = token;
}

export function getToken()
{
    return this._token;
}

export default { get, put, post, del, send, setToken, getToken };
